define([
	"dojo/_base/declare",
	"dojo/Stateful",
	"csi/_base/underscore"
], function(declare,Stateful,_) {

	return declare(Stateful, {
		_set: function(/*String*/ name, /*anything*/ value){
			// summary: Add _set function to be consistent with dijit/_WidgetBase
			var oldValue = this[name];
			this[name] = value;
			if(!_.isEqual(oldValue, value)){
				if(this._watchCallbacks){
					this._watchCallbacks(name, oldValue, value);
				}
			}
		}
	});
});